module.exports = __webpack_public_path__ + "media/images/icon__copy-to-clipboard@3x-07ed56d1fb3ced1c0d2fd2a3d74beb08.png";